import Content1 from "../../../assets/images/projects/blibli-checkout-projects/content1.png";
import Content2 from "../../../assets/images/projects/blibli-checkout-projects/content2.png";
import Content3 from "../../../assets/images/projects/blibli-checkout-projects/content3.png";

import { ProjectDetailProps } from "../props";

export default {
  title: "Compilation of Traveloka projects",
  timeline: "",
  context: "",

  team: [],
  thumbnail: "",
  contents: [
    {
      left: {
        title: "Figma Portfolio",
        content: (
          <div>
            <p>
              It might takes time to load and for better experience please open
              this via Desktop in Chrome browser. And yes you can open this
              figma in full version view.
            </p>
            <iframe
              width="1040"
              height="585"
              src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FvT5ng2qA5Zo3nEuoZh2F6f%2FPortfolio%3Fpage-id%3D0%253A1%26node-id%3D1-470%26viewport%3D927%252C1933%252C0.11%26scaling%3Dscale-down%26starting-point-node-id%3D1%253A470"
              allowFullScreen
            ></iframe>
          </div>
        ),
      },
    },
  ],
} as ProjectDetailProps;
